import { Link } from "react-router-dom";
import { categories } from "@/mocks/home";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2">
            影视分类
          </h2>
          <p className="text-foreground-600 text-sm">
            按类型浏览，快速找到你想看的内容
          </p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-background-200 group-hover:bg-white/20 flex items-center justify-center transition-colors duration-300">
                <i
                  className={`${cat.icon} text-2xl text-primary-500 group-hover:text-white transition-colors duration-300`}
                ></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-white transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}